import CustomComponent from "../CustomComponent";

export class VenueCardComponent extends CustomComponent {
  static key = 'lta-venue-card';

  static get observedAttributes() {
    return ['venue-id', 'venue-name', 'venue-image-url', 'venue-distance-away', 'venue-cta-button-label', 'venue-cta-button-url', 'venue-detail-page-url'];
  }

  constructor() {
    super();
  }

  render() {
    const { venueName, venueImageUrl, venueDistanceAway, venueCtaButtonLabel, venueCtaButtonUrl, venueDetailPageUrl } = this.props;
    return `
      <a href="${venueDetailPageUrl}" class="lta-court-area--card" target="_blank">
        <img alt="Alt text" sizes="100vw" loading="lazy" decoding="async" class="lta-card-img-top" width="2048" height="1152" src="${venueImageUrl}" />
        <div class="lta-court-area--text u-pb-2">
          <h2 class="lta-court-area--venue u-mt-1 u-mb-0">${venueName}</h2>
          <h2 class="u-body1 u-mt-1 u-mb-1">${venueDistanceAway} away</h2>
          <a href="${venueCtaButtonUrl}" type="button" class="lta-btn lta-btn--sm lta-btn--primary u-px-1">${venueCtaButtonLabel}</a>
        </div>
      </a>
    `;
  }
}

export default VenueCardComponent;